module.exports = __webpack_public_path__ + "img/cross.6d9529a5.svg";